import { Box } from '@apia/theme';
import { SemanticSearchReference } from '.';
import { observer } from 'mobx-react-lite';

export const Component = observer(
  (props: { instance: SemanticSearchReference }) => {
    return (
      <Box>
        <a href={props.instance.state.link}>{props.instance.state.title}</a>
        <Box>{props.instance.state.body}</Box>
      </Box>
    );
  },
);
